'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { updateSearchParams, getSearchParams, removeSearchParam, priceFormatter } from "@utils";
import { Combobox } from "@headlessui/react"
import { saleMaxPrices } from '@constants/saleMaxPrices'
import { RiArrowDropDownLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'



const MaxPriceFilter = ({ title, dictionary, lang }) => {
    const router = useRouter();

    const [selectedMaxPrice, setSelectedMaxPrice] = useState(saleMaxPrices[lang].at(-1))
    const [query, setQuery] = useState('')

    const handleUpdateParams = (e) => {
        const minPriceValue = getSearchParams('minprice')
        if (minPriceValue !== null && Number(e.value) < Number(minPriceValue)) {
            setSelectedMaxPrice({ value: minPriceValue, nom: priceFormatter(minPriceValue) })

            let newPathName = updateSearchParams(title, minPriceValue);

            router.push(newPathName);
            router.refresh()
        } else {
            setSelectedMaxPrice(e)
            // const newPathName = updateSearchParams(title, e.value);
            let newPathName
            if (e.value == '0') {
                newPathName = removeSearchParam(title);
            } else {
                newPathName = updateSearchParams(title, e.value);
            }

            router.push(newPathName);
            router.refresh()
        }
    };

    useEffect(() => {
        const maxPriceValue = getSearchParams('maxprice')
        const newValue = saleMaxPrices[lang].find(obj => obj.value === maxPriceValue);
        if (newValue != undefined) {
            setSelectedMaxPrice(newValue)
        } else {
            if (maxPriceValue === null) {
                setSelectedMaxPrice(saleMaxPrices[lang].at(-1))
            } else {
                setSelectedMaxPrice({ value: maxPriceValue, nom: priceFormatter(maxPriceValue) })
            }
        }

    }, [setSelectedMaxPrice])

    const filteredPrices =
        query === ''
            ? saleMaxPrices[lang]
            : saleMaxPrices[lang].filter((price) => {
                if (getSearchParams('minprice') == null) {
                    return price.value.includes(query.toLowerCase())
                } else {
                    return (price.value.includes(query.toLowerCase()) && Number(price.value) >= Number(getSearchParams('minprice')))

                }
            })

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    return (
        <div className='flex flex-col w-1/2 mt-2 sm:px-2 px-0'>
            <span className='text-xl text-secondary mb-1'>{dictionary.maxPrice}:</span>
            <Combobox value={selectedMaxPrice.nom} onChange={(value) => { handleUpdateParams(value) }}>
                <div className="relative w-full">
                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg shadow-md bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' onFocus={() => {
                        }} />
                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                            <RiArrowDropDownLine
                                color={tailwindConfig.theme.extend.colors.secondary}
                                size={28}
                            />
                        </Combobox.Button>
                    </div>
                    <Combobox.Options
                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                        className='z-50 left-0 right-0 absolute bg-white h-auto max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                    >
                        {query.length > 0 && (
                            <Combobox.Option
                                value={{ nom: priceFormatter(query), value: query }}
                                className='py-2 px-4 cursor-pointer color-secondary z-50'

                            >
                                Search price: {priceFormatter(query)}
                            </Combobox.Option>
                        )}
                        {filteredPrices.map((price) => (
                            <Combobox.Option
                                key={price.value}
                                value={price}
                                className='py-2 px-4 cursor-pointer color-secondary z-50'
                            >
                                {price.nom}
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                </div>
            </Combobox>
        </div>
    )
}

export default MaxPriceFilter